"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _designTokens = require("@decisiv/design-tokens");

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _Button = _interopRequireDefault(require("../../components/Button"));

var _Flex = _interopRequireDefault(require("../../components/Flex"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ButtonsRow = (0, _styledComponents.default)(_Flex.default).withConfig({
  displayName: "Footer__ButtonsRow",
  componentId: "sc-1nxwudp-0"
})(["border-top:1px solid ", ";background-color:", ";"], (0, _toColorString.default)(_designTokens.color.opacity.charcoal15), (0, _toColorString.default)(_designTokens.color.opacity.fullMoon50));

function DropdownFooter(props) {
  var actions = props.actions;

  var buttonRender = function buttonRender(_ref) {
    var id = _ref.id,
        rest = _objectWithoutProperties(_ref, ["id"]);

    return _react.default.createElement(_Flex.default, {
      key: id,
      paddingLeft: 0.25,
      paddingRight: 0.25
    }, _react.default.createElement(_Button.default, _extends({
      size: "small"
    }, rest)));
  };

  return Array.isArray(actions) ? _react.default.createElement(ButtonsRow, {
    flex: 1,
    padding: 1
  }, _react.default.createElement(_Flex.default, {
    flex: 1,
    justifyContent: "flex-start"
  }, actions.map(buttonRender))) : _react.default.createElement(ButtonsRow, {
    flex: 1,
    padding: 1
  }, _react.default.createElement(_Flex.default, {
    flex: 1,
    justifyContent: "space-between"
  }, _react.default.createElement(_Flex.default, {
    flex: 1,
    justifyContent: "flex-start"
  }, actions.left && actions.left.map(buttonRender)), _react.default.createElement(_Flex.default, {
    flex: 1,
    justifyContent: "flex-end",
    paddingLeft: 2
  }, actions.right && actions.right.map(buttonRender))));
}

var _default = DropdownFooter;
exports.default = _default;